import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getEvents, getSubPromoterEvents } from "../../services/eventService";
import Loader from "../../components/common/Loader";
import { toast } from "react-toastify";

const EventList = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    Promise.allSettled([getEvents(), getSubPromoterEvents()])
      .then(([ownResult, spResult]) => {
        const ownEvents = (ownResult.status === "fulfilled" ? ownResult.value.data?.Result : null) || [];
        const spEvents = (spResult.status === "fulfilled" ? spResult.value.data?.Result : null) || [];

        // Tag SP events, then merge — dedup by Id (own events take priority)
        const ownIds = new Set(ownEvents.map((e) => e.Id));
        const taggedSpEvents = spEvents
          .filter((e) => !ownIds.has(e.Id))
          .map((e) => ({ ...e, _isAssigned: true }));

        setEvents([...ownEvents, ...taggedSpEvents]);

        if (ownResult.status === "rejected" && spResult.status === "rejected") {
          toast.error("Failed to load events.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loader />;

  return (
    <div>
      <h2 style={styles.heading}>My Events <span style={styles.count}>({events.length})</span></h2>
      {events.length === 0 ? (
        <p style={{ color: "#888" }}>No events found.</p>
      ) : (
        <div style={styles.grid}>
          {events.map((event) => (
            <div
              key={event.Id}
              style={styles.card}
              onClick={() => navigate(`/events/${event.Id}`, { state: { isAssigned: !!event._isAssigned } })}
            >
              {event.Thumbnail ? (
                <img
                  src={event.Thumbnail.replace("\\", "/")}
                  alt={event.Name}
                  style={styles.thumbnail}
                />
              ) : (
                <div style={styles.thumbnailPlaceholder}>🎉</div>
              )}
              <div style={styles.cardBody}>
                <div style={styles.badgeRow}>
                  <div style={styles.badge}>{event.EventType}</div>
                  {event._isAssigned && <div style={styles.assignedBadge}>Sub-Promoter</div>}
                </div>
                <div style={styles.name}>{event.Name}</div>
                <div style={styles.date}>📅 {event.FormattedDate}</div>
                <div style={styles.location}>📍 {event.City}, {event.Country}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  heading: { margin: "0 0 24px", fontSize: 22, fontWeight: 700, color: "#1e1e2d" },
  count: { fontSize: 16, fontWeight: 400, color: "#888" },
  grid: { display: "flex", flexWrap: "wrap", gap: 20 },
  card: {
    background: "#fff",
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
    cursor: "pointer",
    width: 280,
    transition: "box-shadow 0.2s, transform 0.2s",
  },
  thumbnail: { width: "100%", height: 160, objectFit: "cover", display: "block" },
  thumbnailPlaceholder: {
    width: "100%", height: 160, display: "flex",
    alignItems: "center", justifyContent: "center",
    background: "#f0eeff", fontSize: 48,
  },
  cardBody: { padding: "14px 16px 16px" },
  badgeRow: { display: "flex", alignItems: "center", gap: 6, marginBottom: 8, flexWrap: "wrap" },
  badge: {
    display: "inline-block",
    background: "#ede9ff",
    color: "#6c63ff",
    fontSize: 11,
    fontWeight: 600,
    padding: "2px 10px",
    borderRadius: 20,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  assignedBadge: {
    display: "inline-block",
    background: "#fff3cd",
    color: "#b45309",
    fontSize: 11,
    fontWeight: 600,
    padding: "2px 10px",
    borderRadius: 20,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  name: { fontWeight: 700, fontSize: 15, color: "#1e1e2d", marginBottom: 8 },
  date: { fontSize: 12, color: "#6c63ff", marginBottom: 4 },
  location: { fontSize: 12, color: "#555", marginBottom: 4 },
};

export default EventList;
